const ExperienceData = [
  {
    id: 0,
    companyName: "Deloitte",
    jobRole: "Software Engineer (Consultant)",
    startDate: "April 2025",
    endDate: "Present",
    bulletPoints: [
      "Engineering highly scalable and reliable REST APIs using Java, Spring Boot and OracleDB to support enterprise aplications.",
      "Designing unit and integration tests using JUnit and Mockito to ensure code quality and reliability.",
      "Implementing a CI/CD pipeline to automate testing and deployment of backend services on the cloud.",
    ],
    projectLink: false,
    projectLinkUrl: "",
  },
  {
    id: 1,
    companyName: "Peyto Creative",
    jobRole: "Full Stack Software Developer (Part time)",
    startDate: "November 2023",
    endDate: "December 2024",
    bulletPoints: [
      "Collaborated with stakeholders to define project scope, gather requirements, and deliver customized inspection management solutions using React, Redux, Node, and PostgreSQL.",
      "Owned the full software development lifecycle, ensuring alignment with business needs, and conducted thorough testing and deployment.",
      "Managed project timelines and risks, ensuring the solution was delivered on time and met quality standards.",
      "Authored comprehensive documentation and reports on software requirements, API specifications and ERD.",
    ],
    projectLink: false,
    projectLinkUrl: "",
  },
  {
    id: 2,
    companyName: "Jify",
    jobRole: "Software Developer",
    startDate: "April 2022",
    endDate: "November 2023",
    bulletPoints: [
      "Developed distributed, scalable microservices on AWS and Serverless, ensuring high availability and reliability for core financial services.",
      "Led HRMS integrations for 15+ corporations, working closely with corporate clients to deliver customized financial solutions to over 1 million employees.",
      "Acted as a trusted advisor to corporate clients, translating technical concepts into business-friendly language to facilitate decision-making.",
      "Architected the “Digital Gold Trading” project, integrating real-time financial investment features with a focus on data security.",
      "Implemented error monitoring and debugging for microservices using Sentry, improving incident response time by 30%.",
    ],
    projectLink: false,
    projectLinkUrl: "",
  },
  {
    id: 3,
    companyName: "OnTribe",
    jobRole: "Co-Founder/CTO",
    startDate: "February 2020",
    endDate: "September 2021",
    bulletPoints: [
      "Developed a secure NodeJS and ExpressJS server and deployed it on GCP and Digital Ocean virtual machines.",
      "Regulated weekly security checks of the web application using Snyk and unit testing of new features.",
      "Implemented cloud storage for uploading pictures, files and videos using Cloudinary.",
      "Created a meeting scheduler from scratch using Google Calendar APIs instead of using the third-party service called Calendly which reduced technical costs by 30%.",
      "Mentored 4 backend development interns and regularly trained and delegated work to them.",
    ],
    projectLink: true,
    projectLinkUrl: "https://www.ontribe.in/",
  },
  {
    id: 4,
    companyName: "MediaKrafts",
    jobRole: "Web Developer",
    startDate: "January 2020",
    endDate: "March 2020",
    bulletPoints: [
      "Wrote clean HTML, CSS and JavaScript code, integrated designs, extensions and third party APIs according to the project's needs.",
      "Increased responsivity of the website for most devices by writing responsive code in CSS.",
      "Designed web pages to be consistent across highly used browsers like Firefox, Google Chrome and Safari.",
    ],
    projectLink: true,
    projectLinkUrl: "https://mediakrafts.com/",
  },
];

export default ExperienceData;
